//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import './FormNivel1.css';
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import nivel1Context from '../../context/nivel1Context/nivel1Context';
import activoContext from '../../context/activoContex/activoContex';
import { estructuraNivel1 } from '../../utils/estructuras';
import DictionaryText from '../dictionaryText/DictionaryText';
import authContext from '../../context/authentication/authContex';
import clienteAxios from '../../config/axios';


/*
    Componente encargado de mostrar el formulario de usuario.
        Donde data es el usuario crear/modificar.
              minimizar es la función encargada de ocultar el dialogo.
              generar es la función del context que guarda el usuario.
              titulo es la que determina que texto mostrar en encabezado del dialogo.
              verficaUser es la función del context que comprueba la licencia por usuario vigente del cliente.
*/
function FormNivel1({ data, minimizar, nuevoEditado, formDato, handleChangeUbicaciones, i, generar = () => console.log("Generando"), listaUsuarios = [] }) {
    
    const {actualizaractivoList} = useContext(activoContext)
    const aContext = useContext(nivel1Context);
    const {agregarNivel1, actualizarNivel1List, modificarNivel1, eliminarNivel1} = aContext;
    const {getValorActualFromDictionary} = useContext(authContext);

    //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
    const [nivel1, setNivel1] = useState((data !== undefined && nuevoEditado == 'Modificar') ? {group: {codNivel1:data?.codNivel1, name: data?.name, descrp:data?.descrp, direccion: data?.direccion || '', lat: data?.lat || null, lng: data?.lng || null}} : {group: {codNivel1:"",name: '',descrp:"", direccion: '', lat: null, lng: null}, members: []});
        
    //Constante que define el titulo que corresponde si vienen datos por parametros
    //const titulo = (data?.id === "" || data?.id ===  undefined) ? 'Agregar' : 'Modificar';
    const [titulo, setTitulo] = useState(nuevoEditado)
    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};

        if (nivel1.group.codNivel1 === '' || nivel1.group.codNivel1 === undefined) return newErrors.codigo = 'El código debe ser colocado'
        if (nivel1.group.name === '' || nivel1.group.codNivel1 === undefined) return newErrors.nombre = 'El nombre debe ser colocado'
        if (nivel1.group.descrp === '' || nivel1.group.descrp === undefined) return newErrors.nombre = 'La descripción debe ser colocada'

        return '';
        
    };

    const handleGeocodificar = async () => {
        try {
            const resp = await clienteAxios.get(`/geocode?address=${encodeURIComponent(nivel1.group.direccion)}`);
            const { lat, lng } = resp.data.data;
            setNivel1({ ...nivel1, group: { ...nivel1.group, lat, lng } });
        } catch (err) {
            Swal.fire({ icon: 'warning', title: 'No se pudo geocodificar',
                text: err.response?.data?.message || 'Verifique la direccion ingresada' });
        }
    };

    const handlerGenerar = async ()  => {
        
        const errorAxi = validacion();

        if ( errorAxi === "" ) {

            try {
                const dato = nivel1.group;
                const res = await agregarNivel1(dato);
                if (res !== null) {
                    Swal.fire({
                        title: `Guardado exitosamente!`,
                        icon: 'success',
                        // text: `El Tipo de Activo es: ${res.name}`,
                        text: `Código: ${res.lv1Saved.codNivel1} \n Nombre: ${res.lv1Saved.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizaractivoList();
                    actualizarNivel1List();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }

        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }  
    }

    const handlerModificar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "") {
    
            try {
                const dato = {
                    id: data.id,
                    codNivel1:nivel1.group.codNivel1,
                    name: nivel1.group.name,
                    descrp: nivel1.group.descrp,
                    direccion: nivel1.group.direccion,
                    lat: nivel1.group.lat,
                    lng: nivel1.group.lng
                }
                
                const res = await modificarNivel1(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Modificado exitosamente!`,
                        icon: 'success',
                        text: `Nombre: ${res.name}\n Código: ${res.codNivel1}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarNivel1List();
                    actualizaractivoList();
                    minimizar({...dato, label: res.name, value:res.name});
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }  
 
    }

    const handlerEliminar = () => {
        const dato = {
            id: data.id,
            codNivel1:nivel1.group.codNivel1,
            name: nivel1.group.name,
            descrp: nivel1.group.descrp 
        }

        Swal.fire({
            title: `Estas seguro que deseas eliminar ${data.name}?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = data.id
                const resp = await eliminarNivel1(id);
                if(resp === "No se puede borrar la nivel1 porque contiene una nivel2") {
                    Swal.fire({
                        title: `No puede eliminarse!`,
                        icon: 'warning',
                        text: `Para poder eliminar no tiene que tener ${getValorActualFromDictionary("Nivel2")}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                        
                    })
                    
                    minimizar({...dato, label: dato.name, value:dato.name});
                }else{
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `Eliminado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizaractivoList();
                    actualizarNivel1List();
                    minimizar(null);
                    handleChangeUbicaciones({},i,'nivel1',{...estructuraNivel1})
                }    
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo

                minimizar({...dato, label: dato.name, value:dato.name});
            }
            });
    }

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} <DictionaryText text={"Nivel 1"}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de <DictionaryText text={"Nivel 1"}/>: </div>
                <input disabled={ titulo === "Modificar"} value={nivel1.group.codNivel1} className='label-form-group-data' onChange={data => setNivel1({ ...nivel1, group: {...nivel1.group, codNivel1: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={nivel1.group.name} className='label-form-group-data' onChange={data => setNivel1({ ...nivel1, group: {...nivel1.group, name: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Descripción: </div>
                <textarea className='label-form-group-data' value={nivel1.group.descrp} onChange={data => setNivel1({ ...nivel1, group: {...nivel1.group, descrp: data.target.value} })}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Direccion (opcional): </div>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                    <input
                        value={nivel1.group.direccion || ''}
                        className='label-form-group-data'
                        style={{ flex: 1 }}
                        placeholder="Ej: Av. Corrientes 1234, CABA"
                        onChange={e => setNivel1({...nivel1, group: {...nivel1.group, direccion: e.target.value, lat: null, lng: null}})}
                    />
                    {nivel1.group.direccion && !nivel1.group.lat && (
                        <button type="button" className="geocodeBtnOPD" onClick={handleGeocodificar}>Validar</button>
                    )}
                    {nivel1.group.lat && <span style={{ color: 'green', fontSize: '0.8rem' }}>&#10003; Validada</span>}
                </div>
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button> 
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )

                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(formDato.activoNivel1)}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormNivel1;